import React, { Component } from 'react';
import { NavLink, Link } from "react-router-dom";
import FeedBack24 from '../Assets/ratings-review.png';
import Submit24 from '../Assets/submit-24.webp';
import Resubmit24 from '../Assets/resubmit-24.png';
import Review24 from '../Assets/review-24.png';
import MyReview24 from '../Assets/myreview-24.png';
import MySubmission24 from '../Assets/mysubmission-24.jpeg';
import Download24 from '../Assets/download-24.png';
import Publisher24 from '../Assets/publisher-24.png';
import Folder24 from '../Assets/folder-24.jpeg';
import Wallet24 from '../Assets/wallet-24.png';
import Summary24 from '../Assets/summary-24.png';
import Details24 from '../Assets/details.png';
import Footer from "../Components/footer";
import  Header  from "../Components/header";
import SideBar from "../Components/sidebar";
import { getSession, RedirectNotLogin } from "../Components/function";
import { ApiEndpoint, YTVideo1, YTVideo2, appUrl } from '../Constant';
/*import { ShareSocial } from 'react-share-social';


const style = {
  background: 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)',
  borderRadius: 3,
  border: 0,
  color: 'white',
  padding: '0 30px',
  boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
  margin: '0 auto',
};

const RSSUsage = () => {
  return (<ShareSocial 
     style={style}
     url={appUrl}
     subject='Contact'
     body='Hello'
     separator=' '
     socialTypes={['whatsapp','telegram','facebook','twitter','email','linkedin','mailru']}
     //socialTypes={['whatsapp','telegram','facebook','twitter','email','reddit','linkedin','hatena','linkedIn','reddit','line','instapaper','livejournal','ok','mailru']}
   />);
}*/

class Dashboard extends Component{

  constructor(props){
    super(props);
    
    this.state = {
      userID : '',
      password: '',
      message: '',
    }
    }
    
    componentDidMount(){
      RedirectNotLogin();
    }

    componentDidUpdate() {
      RedirectNotLogin();
    }
 
  render(){
    return (
        <div className="App AppWrap">
    
    <Header self={this}/>
    <SideBar self={this}/>

    <div className="App iBG dash-dash">
    <div className="containers">
   
  
  <div className="card-lt-wrap">
    <div className="card-lt" style={{textAlign: 'left'}}>


    {getSession('contractor') == '0' ? 
      (<><NavLink to="/submit">
        <div className="btn-lt">
         <div className="center-img-lt">
           <img height="50px" src={Submit24} alt="Submit File"/>
           </div> 
        <div className="btn-text-lt">
        Submit File
        </div>
        </div>
        </NavLink>

        <NavLink to="/resubmit">
        <div className="btn-lt">
         <div className="center-img-lt">
           <img height="50px" src={Resubmit24} alt="Resubmit File"/>
           </div> 
        <div className="btn-text-lt">
        Resubmit File
        </div>
        </div>
        </NavLink>

        <NavLink to="/my-submission">
        <div className="btn-lt">
         <div className="center-img-lt">
           <img height="50px" src={MySubmission24} alt="My Submissions"/>
           </div> 
        <div className="btn-text-lt">
        My Submissions
        </div>
        </div>
        </NavLink>

        <NavLink to="/my-review">
        <div className="btn-lt">
         <div className="center-img-lt">
           <img height="50px" src={MyReview24} alt="My Reviews"/>
           </div> 
        <div className="btn-text-lt">
        My Reviews
        </div>
        </div>
        </NavLink>

        <NavLink to="/feedback">
        <div className="btn-lt">
         <div className="center-img-lt">
           <img height="50px" src={FeedBack24} alt="Feedbacks"/>
           </div> 
        <div className="btn-text-lt">
        Feedbacks
        </div>
        </div>
        </NavLink>

        <NavLink to="/review">
        <div className="btn-lt">
         <div className="center-img-lt">
           <img height="50px" src={Review24} alt="Review"/>
           </div> 
        <div className="btn-text-lt">
        Peer Review
        </div>
        </div>
        </NavLink>

        <NavLink to="/publisher">
        <div className="btn-lt">
         <div className="center-img-lt">
           <img height="50px" src={Publisher24} alt="Publisher"/>
           </div> 
        <div className="btn-text-lt">
        Publisher
        </div>
        </div>
        </NavLink>

        <NavLink to="/wallet">
        <div className="btn-lt">
         <div className="center-img-lt">
           <img height="50px" src={Wallet24} alt="Wallet"/>
           </div> 
        <div className="btn-text-lt">
        Wallet
        </div>
        </div>
        </NavLink>

        <NavLink to="/repository">
        <div className="btn-lt">
         <div className="center-img-lt">
           <img height="50px" src={Folder24} alt="Repository"/>
           </div> 
        <div className="btn-text-lt">
        Repository
        </div>
        </div>
        </NavLink>
        
        <a href={ApiEndpoint+"/download?l=uploads/site/whitepaper.pdf"}>
        <div className="btn-lt" styleX={{background: '#FF5BB9'}}>
         <div className="center-img-lt">
           <img height="50px" src={Download24} alt="WhitePaper"/>
           </div> 
        <div className="btn-text-lt">
          Download WhitePaper
        </div>
        </div>
        </a>
        </>) : 

        (<>
        <NavLink to="/publisher">
        <div className="btn-lt">
         <div className="center-img-lt">
           <img height="50px" src={Publisher24} alt="Publisher"/>
           </div> 
        <div className="btn-text-lt">
        Publisher
        </div>
        </div>
        </NavLink>

        <NavLink to="/downloads">
        <div className="btn-lt">
         <div className="center-img-lt">
           <img height="50px" src={Folder24} alt="My Downloads"/>
           </div> 
        <div className="btn-text-lt">
        My Downloads
        </div>
        </div>
        </NavLink>

        <NavLink to="/details">
        <div className="btn-lt">
         <div className="center-img-lt">
           <img height="50px" src={Details24} alt="Publisher Details"/>
           </div> 
        <div className="btn-text-lt">
        Publisher Details
        </div>
        </div>
        </NavLink>

        <NavLink to="/wallet">
        <div className="btn-lt">
         <div className="center-img-lt">
           <img height="50px" src={Wallet24} alt="Wallet"/>
           </div> 
        <div className="btn-text-lt">
        Wallet
        </div>
        </div>
        </NavLink>

        <NavLink to="/summary">
        <div className="btn-lt">
         <div className="center-img-lt">
           <img height="50px" src={Summary24} alt="Summary"/>
           </div> 
        <div className="btn-text-lt">
        Summary Page
        </div>
        </div>
        </NavLink>

        <a href={ApiEndpoint+"/download?l=uploads/site/contract.pdf"}>
        <div className="btn-lt">
         <div className="center-img-lt">
           <img height="50px" src={Download24} alt="Contract"/>
           </div> 
        <div className="btn-text-lt">
        Download Contract
        </div>
        </div>
        </a>

        <a href={ApiEndpoint+"/download?l=uploads/site/guidelines.pdf"}>
        <div className="btn-lt">
         <div className="center-img-lt">
           <img height="50px" src={Download24} alt="Guidelines"/>
           </div> 
        <div className="btn-text-lt">
          Download Guidelines
        </div>
        </div>
        </a>

        </>)}
        
        </div>

        <div>
       <div className="card-lt" style={{padding: '15px'}} hidden={(getSession('contractor') == 1)}>
       <div className="chip span successX">
      {(getSession('reviewer') && getSession('reviewer') > 0) ?
      (<>
      <div> <i className="fa fa-star"> </i> Reviewer's Account</div>
      </>) : (
      <>
      <div> <i className="fa fa-user"> </i> Standard Account</div>
      </>
      )}
      </div>
      {(getSession('editor') && getSession('editor') > 0) ?
      (<>
      <div className="chip span primaryX"><i className="fa fa-star"> </i> Editor's Role</div>
      </>) : (
      <>
      
      </>
      )}
       </div>
       
       <div className="card-lt" hidden={(getSession('contractor') == 0)}>
       <div className="chip span successX">
      {(getSession('contractor') && getSession('contractor') > 0) ?
      (<>
      <div> <i className="fa fa-star"> </i> Contractor's Account</div>
      </>) : (
      <>
      <div> <i className="fa fa-user"> </i> Standard Account</div>
      </>
      )}
      </div>
       </div>
       </div>

       <div style={{textAlign: 'center', background: '#0766C6', padding: '15px', paddingTop: '25px', paddingBottom: '0px', marginBottom: '50px'}}>
       <h2 style={{color: '#fff'}} className="hidden">Feeds & Videos:</h2>

       {getSession('div_message') && getSession('div_message') != 'undefined' && getSession('div_message') != undefined && undefined !== getSession('div_message') && getSession('div_message') != "" && getSession('div_message') != null && getSession('div_message') != 'null' ?
       (<>
      
       <div class="marq-box">
  
      <marquee id="scrollUpdateDash" height="35" width="100%" behavior="scroll" direction="left" scrollamount="5" onmouseover="this.stop();" onmouseout="this.start();">
    
     <ul class="marq">
      <li>{getSession('div_message')}</li>
     </ul>
    
      </marquee>
      </div>

       <div className="hidden">
       <div id="scrollNewsUpdate">
       <div className="scroll-container-wrap">
       <div id="scroll-container">
       <div id="scroll-text">
       {getSession('div_message')}
       </div>
       </div>
       </div>
       </div>
       </div>
       </>) : (<></>)}

      {YTVideo1 && YTVideo1 != undefined && YTVideo1 != 'undefined' && YTVideo1 != "" && YTVideo2 && YTVideo2 != undefined && YTVideo2 != 'undefined' && YTVideo2 != "" ?
       (<><div className="embed-video-container">
       <div className="embed-container ratio-16-9">
           <iframe width="560" height="315" src={YTVideo1} title="USP Walkthrough" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
         </div>

         <div className="embed-container ratio-16-9">
         <iframe width="560" height="315" src={YTVideo2} title="Advanced walkthrough video" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
         </div>
         
         </div>
         </>) : (<></>)}

        </div>
        
       {/* <div style={{textAlign: 'center', background: '#0766C6', padding: '15px', paddingBottom: '0px', marginBottom: '50px'}}>
       <h2 style={{color: '#fff'}}>Share This Website:</h2>
       
        <RSSUsage />
      </div>*/}

        <Footer classX="dash-footer"/>

    </div>
    
    </div>

    </div>

    </div>
    );
}

}

export default Dashboard;